function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 3.214A3.214 3.214 0 015.214 0H9.62a3.214 3.214 0 013.214 3.214v23.572A3.214 3.214 0 019.62 30H5.214A3.214 3.214 0 012 26.786V3.214zm15.167 0A3.214 3.214 0 0120.38 0h4.405A3.214 3.214 0 0128 3.214v23.572A3.214 3.214 0 0124.786 30H20.38a3.214 3.214 0 01-3.214-3.214V3.214z",
  fill: "currentColor"
})));